import DecomptesPage from '../../pages/decomptes/DecomptesPage';
import DecomptesIcon from '@mui/icons-material/Assignment';


export const DecomptesRoutes = [
    // ############# Prestations ###############

    {
        name : "decomptes",
        title : "Décomptes",
        path : "/ui/decomptes",
        component : DecomptesPage,
        icon: <DecomptesIcon/>,
        private : true,
        showMenu: false,
        roles: [
            'ROLE_INSURED',
            'ROLE_COMPANY',
            'ROLE_ADMIN_COMPANY',
        ]
    },
]
